import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { font } from "../../../../styles/font";
import { theme } from "../../../../styles/theme";

import { ButtonCustom } from "../../../button";
import { HttpStatusCode } from "axios";

import { ApplicationContext } from "../../../../context/application_ctx";
import {
  AddressElement,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { licencePurchase, updateLicencePurchase } from "../../../../api/controllers/userController";

export const StripePayment = ({
  setError,
  loginQuery,
  setSignInSnack,
  upgrade,
  paymentAmount,
}) => {
  const {
    clientSecret,
    setSubDialog,
    subDialog,
    setReloadProfile,
    selectedNoOfEmployees,
    setProfileSnack,
    setClientSecret
  } = useContext(ApplicationContext);
  console.log(selectedNoOfEmployees, "selectedStr");
  const [loaderState, setLoaderState] = useState(false);
  const [addressSwitch, setAddressSwitch] = useState(false);
  const [address, setAddress] = useState({});

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    setLoaderState(true);
    event.preventDefault();

    if (elements == null) {
      return;
    }

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError) {
      // Show error to your customer
      setLoaderState(false);
      // setErrorMessage(submitError.message);
      console.log(submitError.message);
      return;
    }

    const response = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      clientSecret,
      redirect: "if_required",
      // confirmParams: {
      //   // return_url: "https://example.com/order/123/complete",
      // },
    });

    if (response) {
      if (response?.paymentIntent?.status === "succeeded") {
        apiSubscribeLicence();
      }

      if (response.error) {
        setError(response?.error?.message);
        setLoaderState(false);
        setSignInSnack(true);
      }
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      //   setErrorMessage(error.message);
      console.log(response, "stripeResp");
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  const apiSubscribeLicence = async (plans) => {
    console.log(address,'addressss')
    try {
      let response = await updateLicencePurchase(
        {
          numberOfLicenses: selectedNoOfEmployees,
          paymentAmount,
          address: address.value,
        },
        localStorage.getItem("api-token")
      );
      console.log(response, "responseLoginFInal");
      if (response.status === HttpStatusCode.Ok) {
        // setLoaderState(false);
        setError("Licence purchased successfully");
        setProfileSnack(true);
        setLoaderState(false);
        setReloadProfile(true);
        // localStorage.setItem("api-token", tokenTemp);
        setTimeout(() => {
          setReloadProfile(false);

          // setLoginNavigation(0);
          setSubDialog(false);
          setAddressSwitch(false);
          // navigate("/dashboard");
        }, 2000);

        // setSignInSnack(true);
        // setConfirmModal(false);
        // localStorage.setItem("api-token", tokenTemp);
        // setTimeout(() => {
        //   //   navigate("/dashboard");
        //   setLoginNavigation(4);
        // }, 3000);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        // setLoaderState(false);

        setError(response.data.message);
        // setSignInSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(()=>{
    console.log('yesss  ')
    if(subDialog){

      setTimeout(() => {
        
        elements.getElement(AddressElement).clear()
      }, 500);
    }
  },[subDialog])// eslint-disable-line react-hooks/exhaustive-deps

  const handleAddress = async() =>{
   try {
        let response = await licencePurchase(
          {
            numberOfLicenses: selectedNoOfEmployees,
            paymentAmount,
            address: address.value,
          },
          localStorage.getItem("api-token")
        );
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          // setLoaderState(false);
          setAddressSwitch(true);
          setError(response.data.message);
          setProfileSnack(true);
          setReloadProfile(true);
          setTimeout(() => {
            setReloadProfile(false);

            // setSubDialog(true);

            setClientSecret(response.data.clientSecret);
          }, 2000);

          // setSignInSnack(true);
          // setConfirmModal(false);
          // localStorage.setItem("api-token", tokenTemp);
          // setTimeout(() => {
          //   //   navigate("/dashboard");
          //   setLoginNavigation(4);
          // }, 3000);
        }
        if (response.status === HttpStatusCode.BadRequest) {
          // setLoaderState(false);

          setError(response.data.message);
          // setSignInSnack(true);
        }
      } catch (error) {
        console.log(error);
      }
  }
  return (
    <>
      <Box
        display={"flex"}
        width={loginQuery || upgrade ? "90%" : "60%"}
        height={"100%"}
        gap="35px"
        flexDirection="column"
        justifyContent="center"
      >
        <Box
          display={"flex"}
          flexDirection="column"
          justifyContent="center"
          alignItems={"center"}
          width="100%"
          gap="7px"
        >
          <Box
            display={"flex"}
            width="76px"
            justifyContent="center"
            height="53px"
          >
            <img
              width={"100%"}
              height="100%"
              src={require("../../../../assets/images/logo.png")}
              alt="Mindamigo"
            />
          </Box>
          <Typography
            fontFamily={font.family.fm_2}
            color={theme.col_2}
            textAlign="center"
            fontSize={font.size.fs_2}
            fontWeight="bold"

            // onClick={()=>elements.getElement(AddressElement).clear()}
          >
            Please enter your {addressSwitch ? "card details" : "address"}
          </Typography>
        </Box>
        {!addressSwitch ? (
          <>
            <AddressElement
              onChange={(e) => {
                setAddress(e);
                console.log(e);
              }}
              options={{
                mode: "billing",
                // defaultValues: {
                //   name: "",
                //   address: {
                //     line1: "",
                //     line2: "",
                //     city: "",
                //     state: "",
                //     postal_code: "",
                //     country: "US",
                //   },
                // },
              }}
            />
            <ButtonCustom
              onClick={handleAddress}
              fullWidth={true}
              disabled={loaderState || !address?.complete}
              loaderState={loaderState}
              borderRadius="42px"
              size="large"
              background={theme.col_2}
              backgroundRipple={theme.col_3}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  color={!address?.complete ? theme.col_6 : theme.col_4}
                >
                  Continue
                </Typography>
              }
            />
          </>
        ) : (
          <>
            <PaymentElement />
            <ButtonCustom
              onClick={handleSubmit}
              fullWidth={true}
              disabled={loaderState}
              loaderState={loaderState}
              borderRadius="42px"
              size="large"
              background={theme.col_2}
              backgroundRipple={theme.col_3}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  fontWeight="bold"
                  color={theme.col_4}
                >
                  Pay
                </Typography>
              }
            />
          </>
        )}
      </Box>
    </>
  );
};
